import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { SafePipe } from './pipes/sanitizer.pipe';
import { OnlyNumber } from './directives/only-number.directive';
import { TwoDigitDecimaNumberDirective } from './directives/two-decimal-number.directive';
import { TrimAddressPipe } from './pipes/trim-address.pipe';
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { SignificantDecimalPipe } from './pipes/significant-decimal.pipe';
import { TimeAgoPipe } from './pipes/time-ago.pipe';
import { BonusRewardComponent } from './components/bonus-reward/bonus-reward.component';

@NgModule({
  declarations: [SafePipe, TrimAddressPipe, NumberFormatPipe, SignificantDecimalPipe, TimeAgoPipe, OnlyNumber, TwoDigitDecimaNumberDirective, BonusRewardComponent],
  imports: [CommonModule, TranslatePipe],
  exports: [SafePipe, TrimAddressPipe, NumberFormatPipe, SignificantDecimalPipe, TimeAgoPipe, OnlyNumber, TwoDigitDecimaNumberDirective, BonusRewardComponent],
})
export class SharedModule { }
